import { Box, Button, Card, Checkbox, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import 'react-quill/dist/quill.snow.css';

import ADD_FILE from '../../assets/images/add_file.svg';
import useProductFormController from "../../controllers/product/form";

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ErrorMessageComponent from "../../components/errorMessage";

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ReactPlayer from 'react-player/youtube'
import { isYouTubeUrl } from "../../utils/isYoutubeUrl";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { BrandModel } from "../../models/brand";
import ConfirmDialog from "../../components/ConfirmDialog";
import useProductMerchantFormController from "./controller/formProductMerchantController";
import { MainGroupModel } from "../../models/mainGroup";
import { DivisionModel } from "../../models/division";
import { CategoryModel } from "../../models/category";
import { SubCategoryModel } from "../../models/subCategory";
import { MasterPriceModel } from "../../models/masterPrice";
import SwitchComponent from "../../components/switch";
import { LoadingButton } from "@mui/lab";
import { ProductMerchantModel } from "../../models/productMerchant";
import TextFieldReadAble from "../../components/textFieldReadyAble";
import { StockModel } from "../../models/stock";
import { numberFormat } from "../../utils/nunberFormat";
import { SuppliesMainGroupName } from "../../models/suppliesMain";
interface Props {
    onClose: VoidFunction,
    selectedData: ProductMerchantModel,
    dataMainGroup: MainGroupModel[];
    dataDivisions: DivisionModel[];
    dataCategories: CategoryModel[];
    dataSubCategories: SubCategoryModel[],
    dataBrand: BrandModel[],
    onRefetchData: any,
    merchant: {
        id: string;
        label: string;
    };
    isFormUpdateData: boolean
}

const FormComponent = ({ onClose, selectedData, dataMainGroup, dataDivisions, dataCategories, dataSubCategories, dataBrand, onRefetchData, merchant, isFormUpdateData }: Props) => {
    const { t, i18n } = useTranslation("global");

    const controller = useProductMerchantFormController({
        selectedData,
        onClose,
        onRefetchData,
        merchant,
        isFormUpdateData
    });

    return <>
        {
            !controller.loading
                ?
                <>
                    <IconButton onClick={onClose} sx={{ mb: 2 }}>
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Typography variant="h5">{t("product_merchant_page.Edit product")}</Typography>
                    <Grid sx={{ mt: 2, pl: 2 }} container spacing={2}>
                        <Grid xs={12} sm={9}>
                            <Card sx={{ p: 2, mt: 2 }}>
                                <Typography>{t("product_merchant_page.Item code")}</Typography>
                                <TextFieldReadAble InputProps={{
                                    readOnly: true,
                                }} required value={selectedData?.price?.masterProduct?.itemcode} fullWidth placeholder="Enter Item Code" margin="normal" />
                                {/* <Typography>Pack Type</Typography>

                                <Select
                                    value={controller.selectedPackType}
                                    onChange={controller.handleSelectedPackType}
                                    fullWidth sx={{ mt: 2, maxWidth: 350 }}

                                >

                                    {
                                        controller.dataPackType?.map((item: string) => <MenuItem key={item} value={item}>{item}</MenuItem>)
                                    }
                                </Select> */}
                                {/* <Box sx={{ mt: 2 }}>
                                    <ErrorMessageComponent errorMessage={controller.errorGetProductByItemCodeMessage} />
                                    <LoadingButton onClick={controller.handleGetProductByItemCode} loading={controller.loadingGetProductByItemCode} variant="contained" sx={{ textTransform: 'none' }}>Search Product</LoadingButton>
                                </Box> */}

                                <Typography sx={{ mt: 4 }}>{t("product_merchant_page.Lao name")}</Typography>
                                <TextFieldReadAble InputProps={{
                                    readOnly: true,
                                }} value={selectedData?.price?.masterProduct?.productNameLa} fullWidth margin="normal" />
                                <Typography sx={{ mt: 4 }}>{t("product_merchant_page.English name")}</Typography>
                                <TextFieldReadAble InputProps={{
                                    readOnly: true,
                                }} value={selectedData?.price?.masterProduct?.productNameEn} fullWidth margin="normal" />
                                <Typography sx={{ mb: 2, mt: 1 }}>{t("product_merchant_page.Description")}</Typography>
                                <TextFieldReadAble
                                    fullWidth
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    rows={6}
                                    margin="normal"
                                    ref={controller.description}
                                />
                                <Typography sx={{ mb: 2 }}>{t("Image main")}<span style={{ color: 'red' }}> *</span></Typography>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 240, backgroundColor: '#F4F6F8', borderRadius: '8px', borderStyle: 'dotted', borderColor: '#919EAB52', cursor: 'pointer', gap: 2 }} onClick={() => {
                                        if (controller.imageMainToShow) {
                                            window.open(controller.imageMainToShow);
                                        }
                                    }}>
                                        <img src={controller.imageMainToShow ? controller.imageMainToShow : ADD_FILE} style={{ width: 212, height: 160, objectFit: 'contain' }} alt="" />
                                        <Box>
                                            <Typography fontWeight="bold" fontSize={20}>Select files</Typography>
                                            <Typography color="grey">Drop files here or click browse through you machine </Typography>
                                        </Box>
                                    </Box>
                                </Box>


                                <Typography sx={{ mb: 2, mt: 2 }}>{t("Image secondary")}</Typography>

                                <Box mt={2}>
                                    <Box mt={2} sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        {
                                            controller.imageSecondaryToShow?.map((item: any, index: number) => {
                                                return <Box key={index} sx={{ maxWidth: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                                                    <img src={controller.imageSecondaryToShow[index]} alt="" style={{
                                                        width: 100,
                                                        height: 100,
                                                        cursor: 'pointer',
                                                        objectFit: 'contain'
                                                    }} onClick={() => {
                                                        if (controller.imageSecondaryToShow[index]) {
                                                            window.open(controller.imageSecondaryToShow[index]);
                                                        }
                                                    }} />
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    {
                                        controller.imageSecondaryToShow?.length < 1
                                        &&
                                        <Box>
                                            <Typography color="red">No Secondary images</Typography>
                                        </Box>
                                    }
                                </Box>
                                <Typography sx={{ mb: 2, mt: 2 }}>{t("Video")}</Typography>
                                <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'center' }}>
                                    {
                                        controller.linkVideo
                                            ?
                                            isYouTubeUrl(controller.linkVideo)
                                                ?
                                                <Box sx={{ maxWidth: 500, height: 300, width: '100%' }}>
                                                    <ReactPlayer url={controller.linkVideo} width="100%"
                                                        height="100%" />
                                                </Box>
                                                :
                                                <ErrorMessageComponent errorMessage="Invalid youtube url" />
                                            :
                                            null
                                    }

                                </Box>
                                <a target="open" href={controller.linkVideo}><Typography textAlign="center">{controller.linkVideo}</Typography></a>


                            </Card>
                        </Grid>
                        <Grid xs={12} sm={3} sx={{ p: 2 }}>
                            <Typography fontWeight="bold" sx={{ mb: 5 }}>{t("Product details")}</Typography>
                            {
                                selectedData &&
                                <>
                                    <Typography fontWeight="bold">{t("product_merchant_page.Sale amount")}</Typography>
                                    <TextField inputRef={controller.saleAmount} fullWidth placeholder={t("product_merchant_page.Sale amount") || ""} margin="normal" />
                                </>
                            }
                            <Typography fontWeight="bold">{t("product_merchant_page.Transaction fee")}</Typography>
                            <TextField type="number" inputRef={controller.transactionFee} fullWidth placeholder={t("product_merchant_page.Transaction fee") || ""} margin="normal" />
                            {/* <Typography fontWeight="bold">Delivery date</Typography>
                <TextField inputRef={controller.deliveryDate} fullWidth placeholder="Delivery date" margin="normal" /> */}


                            <Typography fontWeight="bold">{t("Product stock")}</Typography>
                            {/* <TextFieldReadAble InputProps={{
                                readOnly: true, 
                            }} value={dataStock?.filter((subItem) => subItem?.itemcode === selectedData?.price?.masterProduct?.itemcode)[0]?.quantity} fullWidth placeholder={t("Product stock") || ""} margin="normal" /> */}
                            <TextFieldReadAble InputProps={{
                                readOnly: true,
                            }} value={selectedData?.stockQuantity} fullWidth placeholder="Quantity" margin="normal" />
                            <Typography fontWeight="bold">{t("product_merchant_page.UOM")}</Typography>
                            <TextFieldReadAble InputProps={{
                                readOnly: true,
                            }} inputRef={controller.uomType} fullWidth placeholder={t("product_merchant_page.UOM") || ""} margin="normal" />
                            <Typography fontWeight="bold">{t("product_merchant_page.Pack type")}</Typography>
                            <TextFieldReadAble InputProps={{
                                readOnly: true,
                            }} inputRef={controller.packType} fullWidth placeholder={t("product_merchant_page.Pack type") || ""} margin="normal" />

                            <Typography fontWeight="bold">{t("product_merchant_page.Zone")}</Typography>
                            <TextField inputRef={controller.zoneRef} fullWidth placeholder={t("product_merchant_page.Zone") || ""} margin="normal" />
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={controller.recommend} onChange={(e) => controller.setRecommend(e.target.checked)} />
                                <Typography>{t("masterProduct_page.Recommend")}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={controller.productNew} onChange={(e) => controller.setProductNew(e.target.checked)} />
                                <Typography>{t("masterProduct_page.New product")}</Typography>
                            </Box>
                            {/* <Typography fontWeight="bold" sx={{ mb: 2 }}>Brand</Typography>

                <FormControl fullWidth sx={{ mb: 2 }}>
                    <Select
                        value={controller.brand}
                        onChange={controller.handleBrandChange}
                    >
                        {
                            dataBrand?.map((item: BrandModel) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                        }
                    </Select>
                </FormControl> */}
                            <Box mt={2}>
                                {/* <FormControl fullWidth sx={{ mb: 2 }}>
                                    <InputLabel id="main-group-label-id">Main Group</InputLabel>
                                    <Select
                                        // disabled
                                        labelId="main-group-label-id"
                                        id="main-group-id"
                                        value={controller.mainGroup}
                                        label="Main Group"
                                    // onChange={controller.handleMasterMainGroupChange}
                                    >
                                        {
                                            dataMasterMainGroup?.map((item: SuppliesMainGroupName) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.main_group_name_en : item?.main_group_name_la}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl> */}
                                <Typography fontWeight="bold">Main Group</Typography>
                                <TextField value={i18n.language === EN_ACCEPT_LANGUAGE ? dataMainGroup?.filter((item) => item?.id === selectedData?.productMainGroupId)[0]?.supplies_main_group_name?.main_group_name_en : dataMainGroup?.filter((item) => item?.id === selectedData?.productMainGroupId)[0]?.supplies_main_group_name?.main_group_name_la} fullWidth margin="normal" />

                                <Typography fontWeight="bold">Division</Typography>
                                <TextField value={i18n.language === EN_ACCEPT_LANGUAGE ? dataDivisions?.filter((item) => item?.id === selectedData?.productDivisionNameId)[0]?.supplies_division_name?.division_name_en : dataDivisions?.filter((item) => item?.id === selectedData?.productDivisionNameId)[0]?.supplies_division_name?.division_name_la} fullWidth margin="normal" />

                                <Typography fontWeight="bold">Category</Typography>
                                <TextField value={i18n.language === EN_ACCEPT_LANGUAGE ? dataCategories?.filter((item) => item?.id === selectedData?.productCategoryId)[0]?.supplies_product_category?.category_name_en : dataCategories?.filter((item) => item?.id === selectedData?.productCategoryId)[0]?.supplies_product_category?.category_name_la} fullWidth margin="normal" />

                                <Typography fontWeight="bold">Sub Category</Typography>
                                <TextField value={i18n.language === EN_ACCEPT_LANGUAGE ? dataSubCategories?.filter((item) => item?.id === selectedData?.productSubCategoryId)[0]?.supplies_product_sub_category?.sub_category_name_en : dataSubCategories?.filter((item) => item?.id === selectedData?.productSubCategoryId)[0]?.supplies_product_sub_category?.sub_category_name_la} fullWidth margin="normal" />
                                {/* <FormControl fullWidth sx={{ mb: 2 }}>
                                    <InputLabel id="division-label-id">Division</InputLabel>
                                    <Select
                                        // disabled
                                        labelId="division-label-id"
                                        id="division-id"
                                        value={controller.division}
                                        label="Division"
                                    // onChange={controller.handleMasterDivisionChange}

                                    >
                                        {
                                            dataMasterDivisions?.map((item: SuppliesDivisionModel) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.division_name_en : item?.division_name_la}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <InputLabel id="category-label-id">Category</InputLabel>
                                    <Select
                                        // disabled
                                        labelId="category-label-id"
                                        id="category-id"
                                        value={controller.category}
                                        label="Category"
                                    // onChange={controller.handleMasterCategoryChange}
                                    >
                                        {
                                            dataMasterCategories?.map((item: SuppliesCategoryProduct) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.category_name_en : item?.category_name_la}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <InputLabel id="subCategory-label-id">Sub Category</InputLabel>
                                    <Select
                                        // disabled
                                        labelId="subCategory-label-id"
                                        id="subCategory-id"
                                        value={controller.subCategory}
                                        label="Sub Category"
                                    // onChange={controller.handleMasterSubCategoryChange}
                                    >
                                        {
                                            dataMasterSubCategories?.map((item: SuppliesProductSubCategory) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.sub_category_name_en : item?.sub_category_name_la}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl> */}
                            </Box>


                            <Typography fontWeight="bold">{t("Barcode")}</Typography>
                            <Box mt={2}>
                                {
                                    controller?.barcode?.map((item: string, index: number) => {
                                        return <Box key={item}>
                                            <Typography>{index + 1}.</Typography>
                                            <TextFieldReadAble margin="normal" InputProps={{
                                                readOnly: true,
                                            }} value={controller.barcode[index]} fullWidth />
                                        </Box>
                                    })
                                }
                            </Box>

                            <Typography>{t("product_merchant_page.Price")}</Typography>
                            <TextFieldReadAble value={numberFormat(selectedData?.price?.price)} margin="normal" fullWidth InputProps={{
                                readOnly: true,
                            }} />
                            <Typography>{t("product_merchant_page.Discount")}</Typography>
                            <TextFieldReadAble value={numberFormat(selectedData?.promotion?.discountPrice ?? 0)} margin="normal" fullWidth InputProps={{
                                readOnly: true,
                            }} />
                            <Box>
                                <ErrorMessageComponent errorMessage={controller.errorMessage} />
                            </Box>
                            <Box mt={2}>
                                <Button onClick={controller.handleSubmit} variant="contained" sx={{ textTransform: 'none', width: '100%', height: 48 }}>{selectedData ? t("Edit") : t("Add")} {t("product_merchant_page.product")}</Button>
                            </Box>

                        </Grid>
                    </Grid>
                    <ConfirmDialog
                        open={controller.openConfirmDialog}
                        title={`Do you want to update data?`}
                        loading={controller.loadingSubmit}
                        onCancel={() => controller.handleSetOpenConfirmDialog(false)}
                        onConfirm={() => controller.handleConfirmDialog()}
                    />

                </>
                :
                <LinearProgress />
        }
    </>
}
export default FormComponent;